<div class="flex">
  <surveym-star *ngFor="let description of ratingDescriptions; index as i" [description]="description"
            [isHovered]="isStarHoverd(i+1)" class="mr-9" [isSelected]="isStarSelected(i+1)"
            (onSelected)="onStarSelected(i+1)" (onHoverd)="onHoverd(i+1, $event)"></surveym-star>
</div>
